export enum MutationNames {
  UPDATE_PRIMARY_LICENSE = 'UPDATE_PRIMARY_LICENSE',
  LOG_IN = 'LOG_IN',
  LOG_OUT = 'LOG_OUT',
}
